module.exports = __webpack_public_path__ + "static/media/pattern-1.8dea3eb3.webp";